module.exports = __webpack_public_path__ + "static/media/PLAYER3.85ed7a04.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/PLAYER3.png
// module id = 267
// module chunks = 0